<template>
    <div class="inner">
        <div class="xs-left fl">
            <div class="chart-con clearfix">
                <div class="fl w-50">
                    <div class="chart-title">
                        <IconTitle :title="'全国学会所属学科分布'" :iconName="'xinzengdaohangliebiao'" />
                    </div>
                    <div class="chart" id="chart1"></div>
                </div>
                <div class="fr w-50">
                    <div class="chart-title">
                        <IconTitle :title="'全国学会管理体制分布'" :iconName="'gnwyzb'" />
                    </div>
                    <div class="chart" id="chart2"></div>
                </div>
            </div>
            <div class="chart-con clearfix">
                <div class="fl w-50">
                    <div class="chart-title">
                        <IconTitle :title="'全国学会支撑单位类型分布'" :iconName="'renwuzhongxin'" />
                    </div>
                    <div class="chart" id="chart3"></div>
                </div>
                <div class="fr w-50">
                    <div class="chart-title">
                        <IconTitle :title="'全国学会分支机构类型分布'" :iconName="'fenbu'" />
                    </div>
                    <div class="chart" id="chart4"></div>
                </div>
            </div>
            <div class="table-con">
                <IconTitle :title="'全国学会业务主管单位类型分布'" :iconName="'wenjian'"/>
                <div class="rink-con">
                    <div class="estimate_header clearfix">
                        <span>主管单位</span>
                        <span>学会数量</span>
                    </div>
                    <div class="estimate_body" ref="businessUnitList">
                        <div class="estimate_box">
                            <dl v-for="(item, index) in businessUnitCount" :key="index">
                                <dd>{{ item.name }}</dd>
                                <dd>{{ item.num }}</dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="xs-right fr">
            <div class="js-list fl">
                <div class="js-title">
                    <span>{{ internationalOrgSum }}</span> 个<br>
                    加入国际组织
                </div>
                <div class="list-box" ref="internationalOrgSortList">
                    <div class="list-cont">
                        <dl v-for="(item, index) in internationalOrgSort" :key="index">
                            <dd>NO.{{ index + 1 }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.name }}</dd>
                            <dd>{{ item.num }}</dd>
                        </dl>
                    </div>
                </div>
            </div>
            <div class="js-list fl">
                <div class="js-title">
                    <span>{{ prizeSum }}</span> 个<br>
                    设立奖项
                </div>
                <div class="list-box" ref="prizeList">
                    <div class="list-cont">
                        <dl v-for="(item, index) in prizeCount" :key="index">
                            <dd>NO.{{ index + 1 }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.name }}</dd>
                            <dd>{{ item.num }}</dd>
                        </dl>
                    </div>
                </div>
            </div>
            <div class="js-list fl">
                <div class="js-title">
                    <span>{{ periodicalSum }}</span> 个<br>
                    管理期刊
                </div>
                <div class="list-box" ref="periodicalList">
                    <div class="list-cont">
                        <dl v-for="(item, index) in periodicalCount" :key="index">
                            <dd>NO.{{ index + 1 }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.name }}</dd>
                            <dd>{{ item.num }}</dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import IconTitle from '@/components/icontitle';
    import { xhjianshedetail } from "@/assets/scripts/api/xhqj";
    const PIE_COLOR = ['#0054FF', '#0078FF', '#8592FF', '#05C0FB', '#EF9412', '#FB058F'];

    export default {
        name: 'JianSheQingKuang',
        components: {
            IconTitle
        },
        data() {
            return {
                internationalOrgSum:364,//加入国际组织总数
                internationalOrgSort:[],//加入国际组织列表数据
                prizeSum:417, //设立奖项总数
                prizeCount:[],//设立奖项列表
                periodicalSum:1152,//管理期刊总数
                periodicalCount:[],////管理期刊列表
                businessUnitCount:[]//分支机构类型分布
            }
        },
        mounted() {
            this.getDetail();
        },
        methods: {
            getDetail() {
                xhjianshedetail().then((response) => {
                    let classificationCount = response.data.classificationCount, // 学科分布
                        managementSystemCount = response.data.managementSystemCount, // 体制分布
                        supportDepCount = response.data.supportDepCount, // 支撑单位
                        orgCount = response.data.orgCount;

                    this.internationalOrgSum = response.data.internationalOrgSum;
                    this.internationalOrgSort = response.data.internationalOrgSort;
                    this.prizeSum = response.data.prizeSum;
                    this.prizeCount = response.data.prizeCount;
                    this.periodicalSum = response.data.periodicalSum;
                    this.periodicalCount = response.data.periodicalCount;
                    this.businessUnitCount = response.data.businessUnitCount;

                    this.initChart1(classificationCount);
                    this.initChart2(managementSystemCount);
                    this.initChart3(supportDepCount);
                    this.initChart4(orgCount);

                    this.$nextTick(() => {
                        this.$scrollTable(this.$refs.businessUnitList);
                        this.$scrollTable(this.$refs.prizeList);
                        this.$scrollTable(this.$refs.internationalOrgSortList);
                        this.$scrollTable(this.$refs.periodicalList);
                    });
                });
            },
            initRadarCharts(data) {
                const option = {
                    color: PIE_COLOR,
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    series : [
                        {
                            name:'',
                            type:'pie',
                            label: {
                                show: false
                            },
                            radius : ['0', '65%'],
                            data: data
                        }
                    ]
                };

                return option;
            },
            changData(data) {
                let chartArr = [];

                data.forEach((item) => {
                    let obj = {};

                    obj.value = item.num;
                    obj.name = item.name;
                    chartArr.push(obj);
                });

                return chartArr;
            },
            initChart1(data) {
                const chart = echarts.init(document.getElementById("chart1"));

                let dataArr = this.changData(data);

                chart.setOption(this.initRadarCharts(dataArr), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart2(data) {
                const chart = echarts.init(document.getElementById("chart2"));
                let dataArr = this.changData(data);

                chart.setOption(this.initRadarCharts(dataArr), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart3(data) {
                const chart = echarts.init(document.getElementById("chart3"));
                let dataArr = this.changData(data);

                chart.setOption(this.initRadarCharts(dataArr), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart4(data) {
                const chart = echarts.init(document.getElementById("chart4"));
                let dataArr = this.changData(data);

                chart.setOption(this.initRadarCharts(dataArr), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/common.scss";
    .inner{
        padding:1% 2%;
    }
    .xs{
        &-left{
            overflow: hidden;
            height:99%;
            width:40.56%;
            .chart-con{
                height: 31.333333%;
                .w-50{
                    height: 100%;
                    width:48%;
                    .chart{
                        height:calc(100% - 0.4rem);
                    }
                }
            }
            .table-con{
                height: 37.333333%;
                .rink-con{
                    margin-top:0.23rem;
                    border:1px solid #17215F;
                    height:calc(100% - 0.63rem);
                    .estimate_header{
                        span{
                            float:left;
                            height:0.44rem;
                            text-align: center;
                            border-right:1px solid #080B26;
                            font-size:0.14rem;
                            line-height: 0.44rem;
                            color:#E7F0FC;
                            background: #1B276D;
                            &:nth-child(1){
                                width:70%;
                            }
                            &:nth-child(2){
                                width:30%;
                                border:0;
                            }
                        }
                    }
                    .estimate_body{
                        height:calc(100% - 0.48rem);
                        overflow-y: hidden;
                        .estimate_box{
                            dl{
                                overflow: hidden;
                                background: #080B25;
                                &:nth-child(2n){
                                    background: #141D51;
                                }
                            }
                            dd{
                                float: left;
                                height:0.44rem;
                                line-height:0.44rem;
                                font-size:0.16rem;
                                text-align: center;
                                border:1px solid #090C26;
                                color:#B5C8FF;
                                border-right: 0;
                                padding:0 2%;
                                @include text-ellipsis;
                                &:nth-child(1){
                                    width:70%;
                                    border-left:0;
                                }
                                &:nth-child(2){
                                    width:30%;
                                }
                            }
                        }
                    }
                }
            }
        }
        &-right{
            overflow: hidden;
            height:99%;
            width:57.29%;
            border:1px solid #233388;
            box-shadow:inset 0px 0px 150px 0px rgba(39,58,159,0.5);
            background: #080B26;
            .js{
                &-list{
                    padding:2% 2% 0;
                    width:33.33%;
                    height:100%;
                    border-right:1px solid #18266F;
                    &:last-child{
                        border:0;
                    }
                    .list-box{
                        height: 91%;
                        overflow: hidden;
                    }
                    .list-cont{
                        dd{
                            float:left;
                            height:0.55rem;
                            line-height:0.55rem;
                            color:#B5C8FF;
                            font-size:0.16rem;
                            @include text-ellipsis;
                            &:nth-child(1){
                                text-align: left;
                                width:70%;
                            }
                            &:nth-child(2){
                                text-align: right;
                                width:30%;
                            }
                        }
                    }
                }
                &-title{
                    font-size:0.18rem;
                    line-height:0.36rem;
                    color:#B5C8FF;
                    text-align: center;
                    margin-bottom:0.2rem;
                    span{
                        font-size:0.24rem;
                        color:#00CCFF;
                        font-weight: bold;
                    }
                }
            }
        }
    }
</style>